import find from 'lodash/find';
import get from 'lodash/get';
import { removeArrayItem, updateOrPush } from '../arrayModify';

export const addInvitation = (
  state,
  { email, role, invitationId, id, user },
) => {
  const profile = find(get(state, 'list', []), { id });

  if (!profile) return state;

  const pendingInvitations = updateOrPush(
    get(profile, 'pendingInvitations', []),
    { invitationId },
    { email, role, invitationId, userId: id, user },
  );

  const newProfile = {
    ...profile,
    pendingInvitations,
  };

  return {
    ...state,
    list: [...removeArrayItem(get(state, 'list', []), 'id', id), newProfile],
  };
};

export const removeInvitation = (state, { invitationId, userId }) => {
  const profile = find(get(state, 'list', []), { id: userId });

  if (!profile) return state;

  const pendingInvitations = removeArrayItem(
    get(profile, 'pendingInvitations', []),
    'invitationId',
    invitationId,
  );

  const newProfile = {
    ...profile,
    pendingInvitations,
  };

  return {
    ...state,
    list: [
      ...removeArrayItem(get(state, 'list', []), 'id', userId),
      newProfile,
    ],
  };
};

export const removeRole = (state, { userId, memberId }, role) => {
  const list = get(state, 'list', []);
  const listIndex = list.findIndex(item => item.id === userId);
  const memberIndex = get(list[listIndex], 'familyMembers', []).findIndex(
    item => item.id === memberId,
  );

  if (memberIndex !== -1) {
    const newList = [...list];
    const familyMembersList = [...state.list[listIndex].familyMembers];
    const updatedMember = {
      ...state.list[listIndex].familyMembers[memberIndex],
      ...role,
    };

    familyMembersList[memberIndex] = updatedMember;

    const newListItem = {
      ...newList[listIndex],
      familyMembers: familyMembersList,
    };

    newList[listIndex] = newListItem;

    return {
      ...state,
      list: newList,
    };
  }

  return state;
};

export const removeMember = (state, { userId, memberId }) => {
  const list = get(state, 'list', []);
  const listIndex = list.findIndex(item => item.id === userId);
  const removeIndex = get(list[listIndex], 'familyMembers', []).findIndex(
    item => item.id === memberId,
  );

  const filtered = [
    ...state.list[listIndex].familyMembers.slice(0, removeIndex),
    ...state.list[listIndex].familyMembers.slice(removeIndex + 1),
  ];

  const newList = [...list];
  const newListItem = { ...newList[listIndex], familyMembers: filtered };
  newList[listIndex] = newListItem;

  if (removeIndex !== -1) {
    return {
      ...state,
      list: newList,
    };
  }

  return state;
};

export const removeItem = (state, { id }) => {
  const list = removeArrayItem(get(state, 'list', []), 'id', id);

  return { ...state, list };
};



// WEBPACK FOOTER //
// ./src/utils/circles/circlesActions.js